// extracted by mini-css-extract-plugin
export default {"container":"ShareBtn_container__Dt7k5","icon":"ShareBtn_icon__jdRSj","item":"ShareBtn_item__xJY6h"};